import { Outlet, Link, useLocation, Form } from 'react-router-dom';
import { useEffect } from 'react';

import {wpUser,baseUrl} from '../../../k';

export default function SiteError() {
  const location = useLocation();
  useEffect(() => {
    let y = window.localStorage.getItem('baUid');
    console.log({ y });
    if (y != null) {
      //window.location.href = `${wpUser}/dashboard`;
      window.location.href = `${wpUser}/`;
    } else { 
      window.localStorage.clear();
      if (window.location.href.includes("account")) {
        
      }else{
        window.location.href = `${baseUrl}`;
      }
      //causes redirection error
      //window.location.href = `${wpUser}`; 
    } 
  }, [location]);
  return (
    <div>
      {/*
      <p>An Error just occured</p>
    */}
    </div>
  );
}
